import React from "react";
export default function ConsentBanner() {
  return null; // stub: replace with your real consent UI later
}
